module.exports = __webpack_public_path__ + "img/grey-color.5c8d5322.jpg";